module.exports = __webpack_public_path__ + "static/media/skyminer_7.4553273a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skyminer/components/GalleryHDK/images/skyminer_7.png
// module id = 1095
// module chunks = 0